export const PlaqueBuildupSvg = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_6987_4045"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="21"
      >
        <path
          d="M17.4105 9.12216V0.803223C17.4105 0.803223 7.67729 3.82829 4.13796 6.09709C0.598633 8.36589 0.598633 9.8028 0.598633 12.5254C0.598633 15.2479 7.0874 18.9536 10.3318 20.4662C10.3318 20.4662 16.5256 17.8192 17.4105 14.7942C18.2953 11.7691 17.4105 9.12216 17.4105 9.12216Z"
          fill="#FF8A1E"
          fillOpacity="0.8"
        />
      </mask>
      <g mask="url(#mask0_6987_4045)">
        <rect
          width="31.3813"
          height="1.9019"
          transform="matrix(0.913812 0.406138 -0.913812 0.406138 11.0928 -5.20459)"
          fill="#FF8A1E"
        />
        <rect
          width="31.3813"
          height="1.9019"
          transform="matrix(0.913812 0.406138 -0.913812 0.406138 -11.1836 7.90332)"
          fill="#FF8A1E"
        />
        <rect
          width="31.3813"
          height="1.9019"
          transform="matrix(0.913812 0.406138 -0.913812 0.406138 -9.95312 5.71924)"
          fill="#FF8A1E"
        />
        <rect
          width="31.3813"
          height="1.9019"
          transform="matrix(0.913812 0.406138 -0.913812 0.406138 -8.72559 3.53418)"
          fill="#FF8A1E"
        />
        <rect
          width="31.3813"
          height="1.9019"
          transform="matrix(0.913812 0.406138 -0.913812 0.406138 -7.49512 1.34961)"
          fill="#FF8A1E"
        />
        <rect
          width="31.3813"
          height="1.9019"
          transform="matrix(0.913812 0.406138 -0.913812 0.406138 -6.26562 -0.834961)"
          fill="#FF8A1E"
        />
        <rect
          width="31.3813"
          height="1.9019"
          transform="matrix(0.913812 0.406138 -0.913812 0.406138 -5.03906 -3.021)"
          fill="#FF8A1E"
        />
        <rect
          width="31.3813"
          height="1.9019"
          transform="matrix(0.913812 0.406138 -0.913812 0.406138 -3.80762 -5.20459)"
          fill="#FF8A1E"
        />
        <rect
          width="31.3813"
          height="1.9019"
          transform="matrix(0.913812 0.406138 -0.913812 0.406138 -2.5791 -7.38965)"
          fill="#FF8A1E"
        />
        <rect
          width="31.3813"
          height="1.9019"
          transform="matrix(0.913812 0.406138 -0.913812 0.406138 -14.8711 8.7915)"
          fill="#FF8A1E"
        />
      </g>
    </svg>
  );
};
